import api from './api';
import types from './mutation-types';
import moment from 'moment';
import { utils } from '@sfaas/util';

function getRowKey() {
	return moment.now().toString();
}

export default {
	defaultAssign_({ commit }, { key, value }) {
		commit(types.SET_STATE, {
			key,
			value
		});
	},
	onClickSearch_({ state, commit, dispatch }) {
		return dispatch('searchCommCdType_').then(() => commit(types.SET, { key: 'commCdRows', value: [] }));
	},
	searchCommCdTypeOptions_({ state, dispatch, commit }) {
		return api
			.selectCommCdTypeList({ ...state.searchParam, currentPage: 0, pageUnit: 0 })
			.then(({ body: { result }, header }) => {
				if (header.code === 0) {
					result.forEach(row => delete row.totalSize);
					dispatch('setCommCdTypeOptions_', result);
					// dispatch('setUseYnOptions_', result);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	getCommCodes_({ commit, rootState, state }, { key, codeType }) {
		return api
			.getCommCodes({ plantCd: rootState.commonStore.user.plantCd, codeType: codeType })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_STATE, {
						key: key,
						value: data !== null && data !== undefined ? data.body : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	searchCommCdType_({ state, commit }, pagination) {
		const pagingInfo = { ...state.commCdTypePagingInfo, ...pagination };
		return api
			.selectCommCdTypeList({ ...state.searchParam, ...pagingInfo })
			.then(({ body: { result, pagingInfo }, header }) => {
				result.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'commCdTypeRows', value: result });
				commit(types.SET, { key: 'commCdTypePagingInfo', value: pagingInfo });
				commit(types.SET, { key: 'commCdRows', value: [] });
				commit(types.SET, { key: 'currentCommCdType', value: '' });
				return result;
			})
			.catch(error => {
				throw error;
			});
	},
	setCommCdTypeOptions_({ state, commit }, rows) {
		const value = [{ label: 'ALL', value: 'ALL' }].concat(rows.map(({ commCdType }) => ({ label: commCdType, value: commCdType })));
		commit(types.SET, {
			key: 'commCdTypeOptions',
			value
		});
		return value;
	},
	searchCommCd_({ state, commit }, payload) {
		const { commCdType, init, currentPage = 1, pageUnit = 10 } = payload;
		return api
			.selectCommCdList({ commCdType, currentPage, pageUnit })
			.then(({ body: { pagingInfo, result }, header }) => {
				if (header.code === 0) {
					result.forEach(row => delete row.totalSize);
					commit(types.SET, { key: 'commCdRows', value: init || result });
					commit(types.SET, { key: 'commCdPagingInfo', value: pagingInfo });
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	// setUseYnOptions_({ state, commit }, rows) {
	// 	commit(types.SET, {
	// 		key: 'useYnOptions',
	// 		value: [{ label: 'ALL', value: 'ALL' }].concat(rows.map(({ commCd }) => ({ label: commCd, value: commCd })))
	// 	});
	// },
	setCurrentCommCdType_({ state, commit }, value) {
		commit(types.SET, {
			key: 'currentCommCdType',
			value
		});
	},
	addCommCdRow_({ state, commit }) {
		if (!state.currentCommCdType) {
			return;
		}
		const rowKey = getRowKey();
		const addedRow = {
			status: 'I',
			commCdType: state.currentCommCdType,
			commCd: '',
			commCdName: '',
			commCdDesc: '',
			commCdSeq: 1,
			flg1: '',
			flg2: '',
			useYn: 'Y',
			rowKey
		};
		const value = [...state.commCdRows, addedRow];
		commit(types.SET, { key: 'commCdRows', value });
		return addedRow;
	},
	addCommCdTypeRow_({ state, commit }) {
		const rowKey = getRowKey();
		const addedRow = { status: 'I', commCdType: '', commCdTypeName: '', commCdTypeDesc: '', useYn: 'Y', commCdTypeSort: null, rowKey };
		const value = [...state.commCdTypeRows, addedRow];
		commit(types.SET, { key: 'commCdTypeRows', value });
		return addedRow;
	},
	addCommCdDescRow_({ state, commit }) {
		const { selectedRow } = state.commCdDescModal;
		if (utils.$sf_isEmptyObj(selectedRow)) return;
		const { commCdType, commCd } = selectedRow;
		const rowKey = getRowKey();
		// TODO:
		let seq = state.commCdDescRows.length + 1;
		for (let i = 0; i < state.commCdDescRows.length; i++) {
			if (state.commCdDescRows[i].seq !== i + 1) {
				seq = i + 1;
				break;
			}
		}
		const addedRow = { seq, commCdType, commCd, cdDesc: '', title: '', rowKey };
		const value = [...state.commCdDescRows, addedRow];
		commit(types.SET, { key: 'commCdDescRows', value });
		return addedRow;
	},
	onChangeSearchParam_({ state, commit, dispatch }, payload) {
		commit(types.SET_SEARCH_PARAM, payload);
		// if (['commCdType', 'useYn'].includes(payload.key)) {
		// 	return dispatch('searchCommCdType_', { ...state.commCdTypePagingInfo, currentPage: 1 });
		// }
	},
	async saveCommCdType_({ state, dispatch }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		return api.saveCommCdType(rows).then(({ header }) => {
			return dispatch(`searchCommCdType_`, { ...state.commCdTypePagingInfo }).then(() => header);
		});
	},
	deleteCommCdType_({ state, dispatch, commit }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		const rowKeys = rows.map(r => r.rowKey);
		const keys = rows.filter(({ status }) => status !== 'I').map(r => r.commCdType);

		if (keys.length === 0) {
			dispatch('deleteAddedCommCdType_', rowKeys);
			return;
		}
		return api.deleteCommCdType(rows).then(({ header }) => dispatch('searchCommCdType_').then(() => header));
	},
	saveCommCd_({ state, dispatch }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		return api.saveCommCd(rows).then(({ header }) => {
			return dispatch(`searchCommCd_`, { ...state.commCdPagingInfo, commCdType: state.currentCommCdType }).then(() => header);
		});
	},
	deleteCommCd_({ state, dispatch }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		const rowKeys = rows.map(r => r.rowKey);
		const keys = rows.filter(({ status }) => status !== 'I').map(r => r.commmCd);

		if (keys.length === 0) {
			dispatch('deleteAddedCommCd_', rowKeys);
			return;
		}
		const commCdType = state.currentCommCdType;
		return api.deleteCommCd(rows).then(({ header }) => dispatch('searchCommCd_', { commCdType }).then(() => header));
	},
	deleteAddedCommCdType_({ state, commit }, rowKeys) {
		const value = state.commCdTypeRows.filter(({ rowKey }) => !rowKeys.includes(rowKey));
		commit(types.SET, { key: 'commCdTypeRows', value });
		return;
	},
	deleteAddedCommCd_({ state, commit }, rowKeys) {
		const value = state.commCdRows.filter(({ rowKey }) => !rowKeys.includes(rowKey));
		commit(types.SET, { key: 'commCdRows', value });
		return;
	},
	selectCommCdDescList_({ state, commit }, payload) {
		return api
			.selectCommCdDescList(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.SET, { key: 'commCdDescPagingInfo', value: pagingInfo });
					commit(types.SET, { key: 'commCdDescRows', value: resultList });
				} else if (code === 3) {
					// TODO:
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	saveCommCdDescList_: ({ state, commit }, payload) => {
		return api
			.saveCommCdDescList(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	deleteCommCdDescList_: ({ state, commit }, payload) => {
		return api
			.deleteCommCdDescList(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	selectCommCdLangList_({ state, commit }, payload) {
		return api
			.selectCommCdLangList(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { pagingInfo, result } = body;
				if (code === 0) {
					commit(types.SET, {
						key: 'commCdLangModal',
						value: {
							...state.commCdLangModal,
							groups: {
								currentPage: pagingInfo.currentPage,
								pageUnit: pagingInfo.pageUnit,
								totalSize: pagingInfo.totalSize
							}
						}
					});
					commit(types.SET, { key: 'commCdLangRows', value: result });
				} else if (code === 3) {
					// TODO:
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	saveCommCdLangList_({ commit }, param) {
		return api
			.saveCommCdLangList(param)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	deleteCommCdLangList_({ commit }, param) {
		return api
			.deleteCommCdLangList(param)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
